module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }